module["exports"] = [
  "1234-2121-1221-1211",
  "1212-1221-1121-1234",
  "1211-1221-1234-2201",
  "1228-1221-1221-1431"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/business/credit_card_numbers.js
 ** module id = 416
 ** module chunks = 0
 **/